import * as React from 'react'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import { IApiConsumerArray } from '../../data/actions.interface'
import { IAdmin } from '../../data/admin/customer.interface'
import { getCustomerReportsAdmins } from '../../data/admin/customer.actions'
import OTable, { ITableColumn } from '../../components/organisms/OTable'
import AButton from '../../components/atoms/AButton'

interface IReportAdminView extends IApiConsumer {
    users: IApiConsumerArray<IAdmin>
    
    onModify: (row: IAdmin) => string
   
}

const customerUserColumns = (onModify: (row: IAdmin) => string): Array<ITableColumn<IAdmin>> => [
    {
        key: 'name',
        title: 'Name',
        render: row => `${row.firstName} ${row.lastName}`,
    },
    {
        key: 'email',
        title: 'Email',
    },
    {
        key: 'admin',
        title: 'Admin',
        render: row => `${row.isReportsAdmin === null ?'Y':'N'}`,
    },
    {
        key: 'modify',
        render: row => (
            <AButton color="warning" outline to={onModify(row)}>
                Modify report user
            </AButton>
        ),
    },
]

class ReportAdminView extends React.Component<IReportAdminView> {
    render() {
        const { users,  onModify } = this.props

        return <OTable rowKey={'email'} data={users.response} columns={customerUserColumns( onModify)} />
    }
}

export default apiConsumer({
    users: props => getCustomerReportsAdmins(),
})(ReportAdminView)
